<template>
	<!-- Terms Text -->
	<div class="m-auto items-center flex w-full py-4">
		<div class="flex items-center m-auto w-full pr-4">
			<label class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2">
				<input v-model="termsAcceptedBox" type="checkbox" required class="absolute opacity-0 w-0 h-0" />
				<span class="checkmark absolute inset-0 hidden items-center justify-center text-white text-lg">✓</span>
			</label>
			<div class="text-ihh-slate-gray text-sm items-center text-start">
				<span>Yes, I agree with the</span>
				<button
					@click.prevent="showTermsModal = true"
					class="px-0.5 underline capitalize cursor-pointer underline-offset-2 text-ihh-dark-salmon hover:text-ihh-salmon"
				>
					<span>Terms and Conditions.</span>
				</button>
			</div>
		</div>
	</div>

	<!-- Terms Modal -->
	<div class="fixed inset-0 -top-4 flex items-center justify-center bg-ihh-black/20 z-30 backdrop-blur-sm" v-if="showTermsModal" @click.self="showTermsModal = false">
		<div
			class="overflow-scroll overscroll-contain backdrop-blur-sm h-screen sm:h-3/4 w-screen dark:bg-ul-blue-700 bg-white rounded sm:max-w-xl md:max-w-2xl lg:max-w-3xl border border-slate-300 drop-shadow-2xl mx-4"
		>
			<div class="flex w-full p-6 sticky top-0 shadow-lg bg-white z-20">
				<div class="text-ihh-midnight-gray font-semibold flex w-full justify-start text-start text-2xl">Terms and Conditions</div>
				<div class="flex w-full justify-end m-auto items-center">
					<div>
						<button
							@click="showTermsModal = false"
							class="flex group w-8 h-8 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
						>
							<div class="m-auto items-center flex w-full justify-center">
								<div class="rotate-45 absolute rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-px rounded-lg px-2"></div>
								<div class="-rotate-45 rounded bg-ihh-midnight-gray group-hover:bg-ihh-white py-px rounded-lg px-2"></div>
							</div>
						</button>
					</div>
				</div>
			</div>
			<div class="w-full p-6">
				<div class="text-sm text-start text-slate-500">
					<TermsModal />
					<p class="pt-4">Clicking "I Agree" confirms your agreement to these terms.</p>
					<p>
						Click
						<a href="/terms-conditions" target="_blank" class="text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2">here</a>
						to view our full
						<a href="/terms-conditions" target="_blank" class="text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2">Terms & Conditions.</a>
					</p>
				</div>
				<div class="flex w-full justify-center mt-8">
					<button
						@click="agreeToTerms"
						class="flex w-full max-w-40 justify-center text-center text-base py-3 bg-ihh-dark-salmon hover:bg-ihh-dark-salmon/80 font-semibold text-ihh-white rounded uppercase"
					>
						I Agree
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TermsModal from '../pages/ihh-items/terms-modal.vue'
export default {
	name: 'CheckoutTerms',
	emits: ['terms-agreed'],
	components: { TermsModal },
	props: {
		termsAccepted: Boolean,
	},
	data() {
		return {
			termsAcceptedBox: false,
			showTermsModal: false,
		}
	},
	methods: {
		agreeToTerms() {
			this.termsAcceptedBox = true
			this.showTermsModal = false
			this.$emit('update:termsAccepted', true)
			this.$emit('update:showTerms', false)
		},
		handleShowModal() {
			this.showTermsModal = true
		},
	},
	watch: {
		termsAcceptedBox(newVal) {
			this.$emit('update:termsAccepted', newVal)
		},
	},
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.custom-checkbox input[type='checkbox']:checked ~ .checkmark {
	display: flex;
	@apply bg-ihh-dark-salmon;
	border: 0;
}
</style>
